export const mapDefaults = {
	zoom: 5,
	mapBoundingPadding: 80,
	mapDefaultCenter: { lat: 15.7835, lng: -90.2308 } as google.maps.LatLngLiteral,
}
